import { useEffect, useRef } from 'react';
export const CUSTOMER_REGISTRY_EVENT = 'bpm:customer-registry-changed';
let transport = null;
let readers = 0;
let connection = null;
let reconnect;
const invalidateRegistry = () => window.dispatchEvent(new CustomEvent(CUSTOMER_REGISTRY_EVENT, {detail:{kind:'registry'}}));
const connect = async () => {
  if (!transport || !readers || connection) return;
  const controller = new AbortController();
  connection = controller;
  let reader;
  try {
    const response = await transport(controller.signal);
    if (!response.ok || !response.body?.getReader) throw new Error('Registry stream unavailable');
    reader = response.body.getReader();
    const decoder = new TextDecoder();
    let pending = '';
    while (!controller.signal.aborted) {
      const {done,value} = await reader.read();
      if (done) break;
      pending += decoder.decode(value,{stream:true}).replace(/\r/g,'');
      let boundary;
      while ((boundary=pending.indexOf('\n\n')) >= 0) {
        const event=pending.slice(0,boundary);pending=pending.slice(boundary+2);
        if (/^event: registry$/m.test(event) && !controller.signal.aborted) invalidateRegistry();
      }
      if (pending.length > 4096) throw new Error('Invalid registry event');
    }
  } catch { /* Reconnect without interrupting an open form or clearing its data. */ }
  finally {
    if (reader) await reader.cancel().catch(()=>{});
    if (connection === controller) connection = null;
    if (!controller.signal.aborted && readers) reconnect=setTimeout(connect,2000);
  }
};
export const configureCustomerRegistryTransport = factory => {
  transport = factory;
  if (readers && !connection) void connect();
};
const retainStream = () => {
  readers += 1;
  if (readers === 1) void connect();
  return () => {
    readers -= 1;
    if (!readers) {clearTimeout(reconnect);connection?.abort();connection=null;}
  };
};
export const notifyCustomerRegistryWrite = response => {
  const method = String(response?.config?.method || '').toLowerCase();
  const url = String(response?.config?.url || '');
  if (typeof window === 'undefined' || !['post','put','patch','delete'].includes(method)) return;
  const templates = /\/nfse\/templates(?:\/|\?|$)/.test(url);
  const registry = /\/(?:customers|finance\/companies|(?:student-management\/)?young-apprentice\/companies)(?:\/|\?|$)/.test(url);
  if (templates || registry) window.dispatchEvent(new CustomEvent(CUSTOMER_REGISTRY_EVENT, {detail:{kind:templates?'templates':'registry'}}));
};
export const useCustomerRegistryRefresh = refresh => {
  const callback = useRef(refresh);
  callback.current = refresh;
  useEffect(() => {
    let timer;
    const releaseStream = retainStream();
    const schedule = event => {
      clearTimeout(timer);
      const kind = event?.detail?.kind || 'focus';
      timer = setTimeout(() => callback.current(kind), 100);
    };
    window.addEventListener(CUSTOMER_REGISTRY_EVENT, schedule);
    window.addEventListener('focus', schedule);
    return () => { releaseStream(); clearTimeout(timer); window.removeEventListener(CUSTOMER_REGISTRY_EVENT,schedule); window.removeEventListener('focus',schedule); };
  }, []);
};
